// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1dl5F","content":"Consent_content__18f8R","footer":"Consent_footer__2CudJ"};